export default __webpack_public_path__ + "audio/ringtone.mp3";